import { RouteRecordRaw } from "vue-router";

export const plannerRoutes: RouteRecordRaw[] = [
  {
    path: "/service-planner",
    name: "PlannerView",
    component: () => import("../views/PlannerView.vue"),
    meta: {
      requiresAuth: true,
      requiredModule: "planner",
      requiredRight: "viewUI",
    },
  },
];
